import React from 'react';
import WalletTypeView from '@components/WalletTypeView';

export default function WalletWithdrawals({ type, route }) {
  return <WalletTypeView type={type} route={route} />;
}